module.exports = __webpack_public_path__ + "img/remove_red_eye-24px.565d3956.svg";